import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import styles from './Checkbox.styles';

class Checkbox extends Component {
  handleClick = () => {
    this.refs.input.checked = !this.refs.input.checked;
    this.refs.input.dispatchEvent(new Event('input', { bubbles: true }));
  };
  render() {
    const { styles: customStyles, ...rest } = this.props;
    return (
      <div
        className={css(styles.base, customStyles)}
        onClick={this.handleClick}
      >
        <input
          ref="input"
          onClick={this.handleClick}
          className={css(styles.input)}
          type="checkbox"
          {...rest}
        />
        <span className={css(styles.checkmark)} />
      </div>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/inputs/checkbox/Checkbox.js